





































import domToImage from 'dom-to-image'
import Vue from 'vue'
import { WHEEL_OF_LIFE } from '../../config/app.config'

export default Vue.extend({
    methods: {
        add() {
            this.$store.commit('addCategory')
        },
        resetMarks() {
            this.$store.commit('resetMarks')
        },
        resetWheel() {
            this.$store.dispatch('getData', this.$i18n.locale)
        },
        downloadImage() {
            // TODO refactor this. create common loader component
            const loading = this.$loading({
                background: 'rgba(255, 255, 255, 0.7)',
                lock: false,
                spinner: 'el-icon-loading',
                text: this.$t('loading') as string,
            })

            const wrapperToImage = document.getElementById('main-container')
            const link = document.createElement('a')
            link.download = WHEEL_OF_LIFE

            domToImage.toJpeg(wrapperToImage, { bgcolor: 'white', quality: 0.95 })
                .then((dataUrl: any) => {
                    link.href = dataUrl
                }).then(() => {
                    link.click()
                    loading.close()
                })
        },
        // TODO refactor this. Create common helper for all alerts
        alertResetMarks() {
            const that = this
            const resetMarksWarningMessage = this.$t('resetMarksWarning') as string
            const warningMessage = this.$t('warning') as string

            this.$confirm(resetMarksWarningMessage, warningMessage, {
                cancelButtonText: this.$t('cancel') as string,
                confirmButtonText: 'OK',
                type: 'warning',
            })
            .then(() => {
                that.resetMarks()
            })
            .catch(() => {})
        },
        alertResetWheel() {
            const that = this
            const resetWheelWarningMessage = this.$t('resetWheelWarning') as string
            const warningMessage = this.$t('warning') as string

            this.$confirm(resetWheelWarningMessage, warningMessage, {
                cancelButtonText: this.$t('cancel') as string,
                confirmButtonText: 'OK',
                type: 'warning',
            })
            .then(() => {
                that.resetWheel()
            })
            .catch(() => {})
        },
    },
    name: 'ActionBtn',
    props: [
        'label',
        'icon',
        'type',
    ],
})
